import { Dispatch } from "redux";
import { PlanActionTypes } from "../models/planActions";
import { RESET_PLAN } from "../types";

export default (callback: () => void) => async (dispatch: Dispatch<PlanActionTypes>) => {
    dispatch({
        type: RESET_PLAN,
    });
    if (callback) callback();
};